export default __webpack_public_path__ + "static/firefox-1f8666ba5c4da18ec02e97579eb152fa.png";